import uuid from 'uuid';
import widgetInflater from 'components/widgets/inflater';
import { allSections } from 'components/sections';
import { sectionResolver } from 'utils/pageLoader';

export default function inflater(type, store = null) {
  const staticSection = allSections[type];

  if (!staticSection) {
    return false;
  }

  const { defaultWidgets, defaultData, defaultPayload } = staticSection.details;
  const section = {
    id: uuid.v4(),
    type,
    data: defaultData || {},
    payload: defaultPayload || {},
    widgets: defaultWidgets.map(typeOrDetails => widgetInflater(typeOrDetails, store)),
  };

  // Resolve the section's dependencies if we can
  if (store) {
    sectionResolver(store, section);
  }
  return section;
}
